import React, { useState, useEffect,useRef } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Label,
    Button,
    Input,
    //Table,
    Spinner
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as magazineTeamAction from "../../../store/bWFnYXppbm/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import api from "helpers/Api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
    PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ReactDOM from 'react-dom'
import MagazineTeamTabComponent from "./MagazineTeamTabComponent"
import SimpleReactValidator from "simple-react-validator"


const MagazineTeamProductivity = (props) => {
    const { searchBtnStyle, dispatch } = props

    const title = "Magazine Team Productivity"
    //setMagzineTeamData  selectToDate
    const [magzineTeamData, setMagzineTeamData] = useState({
        selectFromDate: "",
        selectToDate: "",
    })
    //Fetching API
    useEffect(() => {
        dispatch(magazineTeamAction.loadRecordsMetaData())
    }, [])
    //Date format
    const sessionUpdate = useSelector((specificstate) => specificstate.session)
    const { user = [] } = sessionUpdate

    const dateSetting =
        !isEmpty(user) && user.setting && user.setting.dateFormate
            ? user.setting.dateFormate.toUpperCase()
            : []
    const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
    //date format
    const update = useSelector((specificstate) => specificstate.magazineTeamProductivity)
    //React Validations
    const simpleValidator = useRef(new SimpleReactValidator())
    const [, forceUpdate] = useState()
    //magazineTeam_data
    const { magazineTeam_data = [], recordsMetaData = {} } = update
    const [viewTable,setViewTable] = useState(false)

    const [employee, setEmployee] = useState([])

    const handleChange = (e) => {
        setMagzineTeamData({ ...magzineTeamData, [e.target.name]: e.target.value })
    }

    const [downloadLoading, setDownloadLoading] = useState(false)
    //Search value

    const [searchFilter, setSearchFilter] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [btnLoader, setBtnLoader] = useState(false)


     const [searchValue, setSearchValue] = useState({})
    const handleFilter = (e) => {
        e.preventDefault()

        var searchEmployee = !isEmpty(employee) && employee ? employee.value : ""

        var searchFromDate =
            magzineTeamData && magzineTeamData.selectFromDate
                ? moment(magzineTeamData.selectFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            magzineTeamData && magzineTeamData.selectToDate
                ? moment(magzineTeamData.selectToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}
        searchvalue.productKey = "MAGAZINE"

        if (searchEmployee) {
            searchvalue.employeeId = searchEmployee
        }
        if (searchFromDate) {
            searchvalue.deliverableFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.deliverableToDate = searchToDate
        }
        setViewTable(true)
        setSearchValue(searchvalue)
        if (simpleValidator.current.allValid()) {
            dispatch(magazineTeamAction.loadMagazineTeamDetails(searchvalue))
        } else {
            simpleValidator.current.showMessages()
            forceUpdate(1)
        }
        setBtnLoader(true)
        setTimeout(() => {
            setBtnLoader(false)
        }, 3000)


    }

    //reset

    const resetForm = () => {
        setViewTable(false)
        setEmployee([])
        setSearchInput("")
        setMagzineTeamData({
            ...magzineTeamData,
            selectFromDate: "",
            selectToDate: ""
        })
      simpleValidator.current.hideMessages()
    }
    //data table
    const productStatusTable = viewTable && magzineTeamData.selectFromDate && magzineTeamData.selectToDate && !isEmpty(magazineTeam_data) && magazineTeam_data.length > 0 ?
        magazineTeam_data.map((data, index) => {
            const empName = !isEmpty(data.employeeCode) && !isEmpty(data.employeeName) ? `${data.employeeCode}-${data.employeeName}` :
                isEmpty(data.employeeCode) && !isEmpty(data.employeeName) ? data.employeeName : "--"
            const clientCountValue = data && data.clientCount ? data.clientCount : 0
            const clientChangesValue = data.CLIENT_CHANGES?data.CLIENT_CHANGES:0
            const clientReworkValue = data.CLIENT_REWORKS?data.CLIENT_REWORKS:0
            const ogPhotosCount = data && data.QuantityCount ? data.QuantityCount : 0
            const rowArray = [clientCountValue, ogPhotosCount,clientChangesValue,clientReworkValue]
            const rowWiseTotal = rowArray.reduce((acc, val) => {
                const accValue = !isNaN(acc) ? acc : 0
                const itemValue = !isNaN(val) ? val : 0
                const data = parseInt(accValue + itemValue)
                return data
            }, 0)
            const productId = recordsMetaData && !isEmpty(recordsMetaData.productOptions) ?
            recordsMetaData.productOptions.find(m => m.label == "MAGAZINE") &&
            recordsMetaData.productOptions.find(m => m.label == "MAGAZINE").value : ""
            return {
                _id: index,
                sNo: index + 1,
                empName: empName,
                empId:data.employeeId,
                clientCount: clientCountValue,
                magazinePhotoCount: ogPhotosCount,
                rowTotal: rowWiseTotal,
                productId:productId,
                clientChanges:clientChangesValue,
                clientRework:clientReworkValue,
            }


        }) : []

    

    const handleClickTab = (tableData) => {
      
        const statusName = tableData.status
        const statusDetails = {
           employeeId:tableData.empId,
           productId:tableData.productId
          
        }
    
        if (searchValue.deliverableFromDate) {
            statusDetails.deliverableFromDate = searchValue.deliverableFromDate
        }
        if (searchValue.deliverableToDate) {
            statusDetails.deliverableToDate = searchValue.deliverableToDate
        }

     
      
        api
        .post(`/get-Productivity-report-details`,statusDetails)
        .then((response) => { 
            const statusData = !isEmpty(response.data.data)?response.data.data:[]
          setTimeout(() => {
            // Use the current value of statusData, which should be updated due to the useEffect
         
            const newTab = window.open("", "_blank", "width=600,height=400")
            if (newTab) {
              const container = newTab.document.createElement("div")
              newTab.document.body.appendChild(container)
              ReactDOM.render(
                <MagazineTeamTabComponent
                  data={statusData} // Use statusData directly here
                  dispatch={dispatch}
                  statusPayload={statusDetails}
                  name={statusName}
                  dateFormat={dateFormat}
                />,
                container
              )
             newTab.document.title = "MAGAZINE-TEAM-PRODUCTIVITY-REPORT"
            }
          }, 2000)
        })
        .catch((error) => {
          Promise.reject(error)
          const newTab = window.open("", "_blank", "width=600,height=400")
            if (newTab) {
              const container = newTab.document.createElement("div")
              newTab.document.body.appendChild(container)
              ReactDOM.render(
                <MagazineTeamTabComponent
                  data={[]} // Use statusData directly here
                  dispatch={dispatch}
                  statusPayload={[]}
                  name={statusName}
                  dateFormat={dateFormat}
                />,
                container
              )
             newTab.document.title = "MAGAZINE-TEAM-PRODUCTIVITY-REPORT"
            }
        })
    }

    const columns = [
        {
            dataField: "sNo",
            text: "S.No",
            footer: ""
        },
        {
            dataField: "empName",
            text: "Employee Name",
            csvExport: false,
            headerStyle: {
                minWidth: "170px",
            },
            formatter: (cellContent, row) => {

                return (
                    <div
                        style={{ textTransform: 'uppercase', fontWeight: 'bold' }}
                    >
                        {row.empName}
                    </div>
                )
            },
            footer: "Grand Total"
        },
        {
            dataField: "clientCount",
            text: "Client Count",
            csvExport: false,
            headerStyle: {
                minWidth: "170px",
            },
            formatter: (cellContent, row) => {
                const tableData = {
                    productId: row.productId,
                    empId: row.empId,
                    status: "Client Count"
                }

                return (
                    <div
                        style={{ fontWeight: 'bold' }}
                        onClick={() => handleClickTab(tableData)}
                    >
                        {cellContent}
                    </div>
                )
            },
            style: {
                color: "#e40d8c",
                fontSize: "14px",
                textDecoration: "underline",
            },
            footer: (columnData) =>
                !isEmpty(columnData) && columnData.length > 0
                    ? columnData.reduce((acc, item) => {

                        const accValue = !isNaN(acc) ? acc : 0
                        const itemValue = !isNaN(item) ? item : 0
                        const data = parseInt(accValue + itemValue)
                        return data
                    }, 0)
                    : 0,
        },
        {
            dataField: "magazinePhotoCount",
            text: "Magzine (Photo Count)",
            csvExport: false,
            headerStyle: {
                minWidth: "170px",
            },
          
            footer: (columnData) =>
                !isEmpty(columnData) && columnData.length > 0
                    ? columnData.reduce((acc, item) => {

                        const accValue = !isNaN(acc) ? acc : 0
                        const itemValue = !isNaN(item) ? item : 0
                        const data = parseInt(accValue + itemValue)
                        return data
                    }, 0)
                    : 0,
        },
        {
            dataField: "clientChanges",
            text: "Client Changes",
            csvExport: false,
            headerStyle: {
                minWidth: "170px",
            },
            formatter: (cellContent, row) => {
                const tableData = {
                //    productId:row.cvValueId,
                    empId:row.empId,
                    status:"Client Changes"
                }
                return (
                    <div
                        style={{ fontWeight: 'bold' }}
                        onClick={() => handleClickTab(tableData)}
                    >
                        {cellContent}
                    </div>
                )
            },
            style: {
                color: "#e40d8c",
                fontSize: "14px",
                textDecoration: "underline",
            },
            footer: (columnData) =>
                !isEmpty(columnData) && columnData.length > 0
                    ? columnData.reduce((acc, item) => {

                        const accValue = !isNaN(acc) ? acc : 0
                        const itemValue = !isNaN(item) ? item : 0
                        const data = parseInt(accValue + itemValue)
                        return data
                    }, 0)
                    : 0,
        },
        {
            dataField: "clientRework",
            text: "Client Rework",
            csvExport: false,
            headerStyle: {
                minWidth: "170px",
            },
            formatter: (cellContent, row) => {
                const tableData = {
                //    productId:row.cvValueId,
                    empId:row.empId,
                    status:"Client Rework"
                }
                return (
                    <div
                        style={{ fontWeight: 'bold' }}
                        onClick={() => handleClickTab(tableData)}
                    >
                        {cellContent}
                    </div>
                )
            },
            style: {
                color: "#e40d8c",
                fontSize: "14px",
                textDecoration: "underline",
            },
            footer: (columnData) =>
                !isEmpty(columnData) && columnData.length > 0
                    ? columnData.reduce((acc, item) => {

                        const accValue = !isNaN(acc) ? acc : 0
                        const itemValue = !isNaN(item) ? item : 0
                        const data = parseInt(accValue + itemValue)
                        return data
                    }, 0)
                    : 0,
        },
        {
            dataField: "rowTotal",
            text: "Total",
            csvExport: false,
            headerStyle: {
                minWidth: "170px",
            },
            footer: (columnData) =>
                !isEmpty(columnData) && columnData.length > 0
                    ? columnData.reduce((acc, item) => {

                        const accValue = !isNaN(acc) ? acc : 0
                        const itemValue = !isNaN(item) ? item : 0
                        const data = parseInt(accValue + itemValue)
                        return data
                    }, 0)
                    : 0,
        },
    ]

    const options = {
        sizePerPage: 50,
        totalSize: magazineTeam_data.length,
        custom: true,
        pageStartIndex: 1,
        firstPageText: "First",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        showTotal: true,
    }


    const handleClick = (e) => {
        e.preventDefault()
        setSearchFilter(true)
        dispatch(magazineTeamAction.loadMagazineTeamDetails({
            searchFilter: searchInput,
            productKey:"MAGAZINE"

        }))
        setTimeout(() => {
            setSearchFilter(false)
        }, 1200)
    }
    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })

        const a = document.createElement("a")
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }


    const exportToCsv = () => {
        var searchEmployee = !isEmpty(employee) && employee ? employee.value : ""

        var searchFromDate =
            magzineTeamData && magzineTeamData.selectFromDate
                ? moment(magzineTeamData.selectFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            magzineTeamData && magzineTeamData.selectToDate
                ? moment(magzineTeamData.selectToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}
         searchvalue.productKey = "MAGAZINE"

        if (searchEmployee) {
            searchvalue.employeeId = searchEmployee
        }
        if (searchFromDate) {
            searchvalue.deliverableFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.deliverableToDate = searchToDate
        }

        setDownloadLoading(true)

        api
            .post(`/get-productivity-Quantity-report`, searchvalue)
            .then((response) => {


                const photoExportDataTable = !isEmpty(response.data.data)
                    ? response.data.data.map((data, index) => {
                        const clientChangesValue = data.CLIENT_CHANGES?data.CLIENT_CHANGES:0
                        const clientReworkValue = data.CLIENT_REWORKS?data.CLIENT_REWORKS:0
                        const empName = !isEmpty(data.employeeCode) && !isEmpty(data.employeeName) ? `${data.employeeCode}-${data.employeeName}` :
                            isEmpty(data.employeeCode) && !isEmpty(data.employeeName) ? data.employeeName : "--"
                        const clientCountValue = data && data.clientCount ? data.clientCount : 0
                        const ogPhotosCount = data && data.QuantityCount ? data.QuantityCount : 0
                        const rowArray = [clientCountValue, ogPhotosCount,clientChangesValue,clientReworkValue]
                        const rowWiseTotal = rowArray.reduce((acc, val) => {
                            const accValue = !isNaN(acc) ? acc : 0
                            const itemValue = !isNaN(val) ? val : 0
                            const data = parseInt(accValue + itemValue)
                            return data
                        }, 0)
                        return {
                            _id: index,
                            sNo: index + 1,
                            empName: empName,
                            clientCount: clientCountValue,
                            ogPhotoCount: ogPhotosCount,
                            rowTotal: rowWiseTotal,
                            clientChanges:clientChangesValue,
                            clientRework:clientReworkValue,
                        }

                    })
                    : []
                setTimeout(() => {
                    let headerData = [
                        "S.No,Employee Name,Client Count,Magazine (Photo Count),Client Changes,Client Rework,Total"
                    ]
                    const columnTotals = photoExportDataTable.reduce((totals, user) => {
                        Object.keys(user).forEach(key => {
                            if (key !== "sNo" && key !== "empName") {
                                totals[key] = !isNaN(totals[key]) ? (totals[key] || 0) : 0
                                user[key] = !isNaN(user[key]) ? user[key] : 0
                                totals[key] += user[key]
                            }
                        })
                        return totals
                    }, {})

                    const columnTotalsRow = {
                        sNo: "",
                        empName: "Grand Total",
                        ...columnTotals
                    }

                    // Add total row to the data
                    photoExportDataTable.push(columnTotalsRow)
                    let usersCsv =
                        !isEmpty(photoExportDataTable) &&
                        photoExportDataTable.reduce((acc, user) => {
                            const {

                                sNo,
                                empName,
                                clientCount,
                                ogPhotoCount,
                                clientChanges,
                                clientRework,
                                rowTotal
                            } = user
                            acc.push([
                                sNo,
                                empName,
                                clientCount,
                                ogPhotoCount,
                                clientChanges,
                                clientRework,
                                rowTotal
                            ])

                            return acc
                        }, [])

                    downloadFile({
                        data: [...headerData, ...usersCsv].join("\n"),
                        fileName: "MagazineTeamProductivity.csv",
                        fileType: "text/csv",
                    })
                    setDownloadLoading(false)
                }, 1000)
                return response.data
            })
            .catch((error) => {
                Promise.reject(error)
                setDownloadLoading(false)
            })
    }
    return (
        <div className="page-content">
            <MetaTags>
                <title>{title} | Zero Gravity CRM</title>
            </MetaTags>
            <Container fluid>
                <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
                <Row>
                    <Col xs={12}>
                        <Card>
                            <CardBody>
                                <form>
                                    <Row>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event From Date"}
                                                >
                                                    {"Select From Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="selectFromDate"
                                                value={magzineTeamData.selectFromDate}
                                                max={magzineTeamData.selectToDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                            <div style={{ textTransform: "capitalize" }}>
                                                {simpleValidator.current.message(
                                                    "Select From Date",
                                                    magzineTeamData.selectFromDate,
                                                    "required"
                                                )}
                                            </div>
                                        </Col>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event To Date"}
                                                >
                                                    {"Select To Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="selectToDate"
                                                value={magzineTeamData.selectToDate}
                                                min={magzineTeamData.selectFromDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                                 <div style={{ textTransform: "capitalize" }}>
                                                {simpleValidator.current.message(
                                                    "Select To Date",
                                                    magzineTeamData.selectToDate,
                                                    "required"
                                                )}
                                            </div>
                                        </Col>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <Label className="employee-label">EW Name</Label>
                                            <Select
                                                type="text"
                                                name="employee"
                                                value={employee}
                                                onChange={(e) => setEmployee(e)}
                                                options={
                                                    recordsMetaData ? recordsMetaData.employeeOptions : []
                                                }
                                                placeholder="Select EW Name"
                                                classNamePrefix="select2-selection"
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                                            <div
                                                className="filter-buttons"
                                                style={{ float: "right" }}
                                            >
                                                <Button
                                                    type="button"
                                                    className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                                                    onClick={() => {
                                                        resetForm()
                                                    }}
                                                >
                                                    <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                    Reset
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    onClick={(e) => handleFilter(e)}
                                                    className="btn btn-success btn-label simple-form-applyfilter-btn"
                                                >
                                                    <i className="bx bx-filter-alt label-icon"></i>
                                                    {btnLoader && btnLoader ? (
                                                        <ButtonSpinner />
                                                    ) : (
                                                        "Apply Filter"
                                                    )}{" "}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md="12" lg="12" xl="12">
                        <Card>
                            <CardBody>

                                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <form onSubmit={handleClick} className="d-flex flex-row">
                                            <div style={searchBtnStyle || null}>
                                                <Input
                                                    type="text"
                                                    name="searchInput"
                                                    value={searchInput}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Search"
                                                    style={{ position: "relative" }}
                                                />
                                                <i
                                                    className="bx bx-search-alt"
                                                    style={{
                                                        position: "absolute",
                                                        top: "54px",
                                                        left: "41px",
                                                        fontSize: "13px",
                                                    }}
                                                />
                                            </div>

                                            <button
                                                className="btn btn-success mx-2"
                                                type="submit"
                                                style={{
                                                    background: searchFilter ? "#2ca67a" : "",
                                                    color: searchFilter ? "#ffffff" : "",
                                                }}
                                            >
                                                <i className="fas fa-search"></i>
                                            </button>
                                        </form>
                                    </div>

                                </div>
                                <Row>
                                    <Col md="4" lg="4" sm="12"></Col>
                                    <Col md="8" lg="8" sm="12" style={{ marginBottom: "20px", marginTop: "-41px" }}>
                                        <div
                                            style={{
                                                float: "right",
                                            }}
                                        >
                                            <Button
                                                className="btn btn-primary"
                                                onClick={exportToCsv}
                                                id="download"
                                                style={{
                                                    backgroundColor: "#e40d8c",
                                                    color: "white",
                                                    border: "none",
                                                }}
                                            >
                                                Download
                                            </Button>
                                        </div>
                                    </Col></Row>

                                <Col md="12" lg="12" xl="12" className="mt-3">


                                    <PaginationProvider
                                        pagination={paginationFactory(options)}
                                    >
                                        {
                                            ({
                                                paginationProps,
                                                paginationTableProps
                                            }) => (
                                                <div>
                                                    <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                                        <Row className="d-flex flex-row  ">

                                                            <Col style={{ overflowX: "auto", width: "100%" }}>
                                                                <BootstrapTable
                                                                    data={productStatusTable}
                                                                    striped={true}
                                                                    noDataIndication={"No Data Found..."}
                                                                    bordered={true}
                                                                    keyField="_id"
                                                                    columns={columns}
                                                                    {...paginationTableProps}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row
                                                            style={{ marginTop: "5px" }}
                                                            className="align-items-md-center mt-30"
                                                        >
                                                            <Col className="inner-custom-pagination d-flex">
                                                                <div className="d-inline d-flex flex-row">
                                                                    <SizePerPageDropdownStandalone
                                                                        {...paginationProps}
                                                                    />
                                                                    <div
                                                                        style={{
                                                                            fontSize: "14px",
                                                                            marginTop: "8px",
                                                                            marginLeft: "4px",
                                                                        }}
                                                                    >
                                                                        <PaginationTotalStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="text-md-right ms-auto"
                                                                    style={{ zIndex: 0 }}
                                                                >
                                                                    <PaginationListStandalone
                                                                        {...paginationProps}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </div>
                                            )
                                        }
                                    </PaginationProvider>


                                </Col>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {downloadLoading ? (
                <Modal
                    show={downloadLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                >
                    <Modal.Body>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                        />
                    </Modal.Body>
                </Modal>
            ) : (
                ""
            )}


        </div>
    )
}
MagazineTeamProductivity.propTypes = {
    dispatch: PropTypes.func,
    searchBtnStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    // employee: state.employeeRequest.employee,MagazineTeamProductivity
})
//MagazineTeamProductivity
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MagazineTeamProductivity)
)
